import { darkGrey, lightGrey } from './const/colors'
import { defaultBorderRadius } from './const/common'

export const smallPageMaxWidth = 680
const containerWidth = 1360

export const container = {
  width: '100%',
  maxWidth: containerWidth,
  margin: '0 auto'
}

export const card = {
  background: 'white',
  border: {
    width: 1,
    style: 'solid',
    color: lightGrey
  },
  borderRadius: defaultBorderRadius
}

export const siteLink = {
  color: darkGrey,
  textDecoration: 'underline',
  '&:hover': {
    cursor: 'pointer'
  }
}

export const disabled = {
  opacity: 0.8,
  pointerEvents: 'none'
}

export const smallPageContainer = {
  maxWidth: smallPageMaxWidth,
  margin: '0 auto'
}

export const hideVisibleScrollbar = {
  // IE, Edge and Firefox
  '-ms-overflow-style': 'none',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    // Chrome, Safari and Opera
    display: 'none'
  }
}

export const scrollableList = {
  display: 'grid',
  overflowY: 'auto'
}
